<template>
  <div>
    <div class="settings-top-bar sticky-header">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="backButton">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="d-inline-flex">
        </p>
      </div>
    </div>
    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg><!---->
      </div>
    </div>
    <div class="row">
      <div class="display-flex" style="align-items: baseline;">
        <div class="col-lg-7 col-md-10 col-sm-12 pad-to-15 display-flex">
            <div class="card">
              <div class="row card-content customer-details">
                <div class="col-md-12 title">
                    <h6 class=""><img class="icon-card-header" src="/static/img/icons/user-sm.png"> {{$t('customers.title')}}</h6>
                    <hr style="clear:both;" class="sm">
                </div>
                <div class="col-md-12 box-bg border-top-left-radius border-top-right-radius">
                  <div class="row pad-bt-15">
                      <div class="col-lg-6 col-sm-6 col-xs-12 details-label">{{$t('customers.id')}}</div>
                      <div class="col-lg-6 col-sm-6 col-xs-12">
                          <template v-if="customer.id" >
                            <span>{{customer.id}}</span>
                          </template>
                          <template v-else>
                            <i class="user-details-incomplete"> - {{$t('general.notCompleted')}} - </i>
                          </template>
                      </div>
                  </div>
                </div>
                <div class="col-md-12 box-bg">
                    <div class="row pad-bt-15">
                        <div class="col-lg-6 col-sm-6 col-xs-12 details-label">{{$t('customers.name')}}</div>
                        <div class="col-lg-6 col-sm-6 col-xs-12">
                            <template v-if="customer.firstname || customer.lastname ">
                              <span>{{customer.firstname}} {{customer.lastname}}</span>
                            </template>
                            <template v-if="!customer.firstname && !customer.lastname">
                            <i class="user-details-incomplete"> - {{$t('general.notCompleted')}} - </i>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 box-bg">
                    <div class="row pad-bt-15">
                        <div class="col-lg-6 col-sm-6 col-xs-12 details-label">{{$t('customers.email')}}</div>
                        <div class="col-lg-6 col-sm-6 col-xs-12">
                            <template v-if="customer.email">
                              <span>{{customer.email}}</span>
                            </template>
                            <template v-if="!customer.email">
                            <i class="user-details-incomplete"> - {{$t('general.notCompleted')}} - </i>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 box-bg">
                    <div class="row pad-bt-15">
                        <div class="col-lg-6 col-sm-6 col-xs-12 details-label">{{$t('customers.phone')}}</div>
                        <div class="col-lg-6 col-sm-6 col-xs-12">
                            <template v-if="customer.phone">
                              <span>{{customer.phone}}</span>
                            </template>
                            <template v-if="!customer.phone">
                            <i class="user-details-incomplete"> - {{$t('general.notCompleted')}} - </i>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 box-bg">
                    <div class="row pad-bt-15">
                        <div class="col-lg-6 col-sm-6 col-xs-12 details-label">{{$t('customers.gender')}}</div>
                        <div class="col-lg-6 col-sm-6 col-xs-12">
                            <template v-if="customer.gender">
                              <span>{{customer.gender}}</span>
                            </template>
                            <template v-if="!customer.gender">
                            <i class="user-details-incomplete"> - {{$t('general.notCompleted')}} - </i>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 box-bg">
                    <div class="row pad-bt-15">
                        <div class="col-lg-6 col-sm-6 col-xs-12 details-label">{{$t('customers.birth')}}</div>
                        <div class="col-lg-6 col-sm-6 col-xs-12">
                        <template v-if="customer.birthdate">
                            <span>{{formatDate(customer.birthdate)}}</span>
                        </template>
                        <template v-if="!customer.birthdate">
                            <i class="user-details-incomplete"> - {{$t('general.notCompleted')}} - </i>
                        </template>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 box-bg">
                    <div class="row pad-bt-15">
                        <div class="col-lg-6 col-sm-6 col-xs-12 details-label">{{$t('customers.dateCreated')}}</div>
                        <div class="col-lg-6 col-sm-6 col-xs-12">
                        <template v-if="customer.created_at">
                            <span>{{formatDate(customer.created_at)}}</span>
                        </template>
                        <template v-if="!customer.created_at">
                            <i class="user-details-incomplete"> - {{$t('general.notCompleted')}} - </i>
                        </template>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 box-bg">
                    <div class="row pad-bt-15">
                        <div class="col-lg-6 col-sm-6 col-xs-12 details-label">{{$t('customers.address')}}</div>
                        <div class="col-lg-6 col-sm-6 col-xs-12">
                            <template v-if="customer.addresses && customer.addresses.length">
                              <span>{{getUserAddress(customer.addresses[0])}}</span>
                            </template>
                            <template v-else>
                              <i class="user-details-incomplete"> - {{$t('general.notCompleted')}} - </i>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 box-bg">
                    <div class="row pad-bt-15">
                        <div class="col-lg-6 col-sm-6 col-xs-12 details-label">{{$t('customers.myGroups')}}</div>
                        <div class="col-lg-6 col-sm-6 col-xs-12">
                            <template v-if="customer.my_groups && customer.my_groups.length">
                                <div class="customer-groups-list">
                                    <div 
                                        v-for="group in customer.my_groups" 
                                        :key="group.id"
                                        class="group-badge"
                                        :class="{ 'approved': group.is_approved, 'pending': !group.is_approved }"
                                    >
                                        <span class="group-name">{{ group.name }}</span>
                                        <span class="group-status">
                                            <template v-if="group.is_approved">
                                                <i class="fa fa-check-circle text-success"></i>
                                                <small>{{$t('customers.approved')}}</small>
                                            </template>
                                            <template v-else>
                                                <i class="fa fa-clock-o text-warning"></i>
                                                <small>{{$t('customers.pendingApproval')}}</small>
                                            </template>
                                        </span>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <i class="user-details-incomplete"> - {{$t('customers.noGroups')}} - </i>
                            </template>
                        </div>
                    </div>
                </div>
                <!-- Active subscriptions (Marketing > Abonamente) -->
                <div class="col-md-12 box-bg">
                  <div class="row pad-bt-15">
                    <div class="col-lg-6 col-sm-6 col-xs-12 details-label">{{$t('marketingSubscriptions.customerActiveSubscriptions')}}</div>
                    <div class="col-lg-6 col-sm-6 col-xs-12">
                      <template v-if="activeSubscriptions.length">
                        <div v-for="item in activeSubscriptions" :key="'cs' + item.id" class="customer-subscription" :class="'customer-subscription--' + item.state">
                          <strong>{{ item.subscription ? item.subscription.name : '-' }}</strong>
                          <span v-if="item.active_until"> · {{ $t('marketingSubscriptions.until') }} {{ item.active_until | formatDate }}</span>
                          <i v-if="!item.auto_renew" class="fa fa-ban customer-subscription__norenew" :title="$t('marketingSubscriptions.autoRenew') + ': ' + $t('marketingSubscriptions.no')"></i>
                        </div>
                      </template>
                      <i v-else class="user-details-incomplete"> - {{$t('marketingSubscriptions.customerNoSubscriptions')}} - </i>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 box-bg">
                  <div class="row pad-bt-15">
                    <div class="col-lg-6 col-sm-6 col-xs-12 details-label">{{$t('customers.pointsTitle')}}</div>
                    <div class="col-lg-6 col-sm-6 col-xs-12">
                      <span>{{customer.loyalty_points}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 box-bg" v-if="customer.orders_count">
                  <h6><div class="col-lg-6 col-sm-6 col-xs-12 pad-bt-10"><img class="icon-card-header" src="/static/img/icons/orders-icon.png"> {{$t('menuLink.orders')}}</div></h6>
                  <div class="col-lg-6 col-sm-6 col-xs-12"><span>{{customer.orders_count}}</span></div>
                  <hr style="clear:both;" class="sm">
                </div>
                <div class="col-md-12 box-bg border-bottom-left-radius border-bottom-right-radius" v-if="customer.delivery_orders_count">
                  <div class="row pad-bt-15">
                    <div class="col-lg-6 col-sm-6 col-xs-12 details-label">{{$t('customers.deliveryOrders')}}</div>
                    <div class="col-lg-6 col-sm-6 col-xs-12"><span>{{customer.delivery_orders_count}}</span></div>
                  </div>
                </div>
                 <div class="col-md-12 box-bg border-bottom-left-radius border-bottom-right-radius" v-if="customer.pickup_orders_count">
                  <div class="row pad-bt-15">
                    <div class="col-lg-6 col-sm-6 col-xs-12 details-label">{{$t('customers.pickupOrders')}}</div>
                    <div class="col-lg-6 col-sm-6 col-xs-12"><span>{{customer.pickup_orders_count}}</span></div>
                  </div>
                </div>
                 <div class="col-md-12 box-bg border-bottom-left-radius border-bottom-right-radius" v-if="customer.meethalfway_orders_count">
                  <div class="row pad-bt-15">
                    <div class="col-lg-6 col-sm-6 col-xs-12 details-label">{{$t('customers.meetHalfwayOrders')}}</div>
                    <div class="col-lg-6 col-sm-6 col-xs-12"><span>{{customer.meethalfway_orders_count}}</span></div>
                  </div>
                </div>
                 <div class="col-md-12 box-bg border-bottom-left-radius border-bottom-right-radius" v-if="customer.reservations_count">
                  <div class="row pad-bt-15">
                    <div class="col-lg-6 col-sm-6 col-xs-12 details-label">{{$t('customers.customerReservations')}}</div>
                    <div class="col-lg-6 col-sm-6 col-xs-12"><span>{{customer.reservations_count}}</span></div>
                  </div>
                </div>
                </div>
            </div> <!-- end card -->
        </div> <!--  end col-md-12  -->
        <div class="col-lg-7 col-md-10 col-sm-12 pad-to-15 display-flex" v-if="!is_marketer">
            <div class="card">
                <div class="row card-content money_section">
                    <div class="col-md-12 title">
                        <h6 class=""><img class="icon-card-header" src="/static/img/icons/points-sm.png">{{$t('customers.pointsAddTitle')}}</h6>
                        <hr style="clear:both;" class="sm">
                    </div>
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                              <label class="details-label mar-rt-10">{{$t('customers.pointsLabel')}} ({{currency}}) <span>1 {{currency}} = {{loyalty_value_one_currency}} {{ loyalty_value_one_currency > 1 ? $t('customers.points') : $t('customers.point') }}</span></label>
                              <input type="number"
                                      min="1"
                                  v-validate=""
                                  v-model="newPoints.money_spent"
                                  @change="calcPoints(1)"
                                  class="form-control"
                                  :disabled="loyalty_usage == 0">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                                <label class="details-label mar-rt-10">{{$t('customers.pointsLabelInPoints')}} <span>{{ loyalty_value_one_point_amount }} {{ loyalty_value_one_point_amount > 1 ? $t('customers.points') : $t('customers.point')}} = {{loyalty_value_one_point}} {{currency}}</span></label>
                                <input type="number"
                                        min="1"
                                    v-validate=""
                                    v-model="newPoints.points_earned"
                                    @change="calcPoints(2)"
                                    class="form-control"
                                    aria-describedby="points-adjustment-help"
                                    :disabled="loyalty_usage == 0">
                                <small id="points-adjustment-help" class="help-block">{{$t('customers.pointsAdjustmentHelp')}}</small>
                            </div>
                          </div>
                          <div class="col-md-6"></div>
                          <div class="col-md-6"><span>{{$t('customers.clientCanUse')}} {{loyalty_value_one_point/loyalty_value_one_point_amount * newPoints.points_earned}} {{currency}}</span></div>
                        </div>
                        <div class="form-group">
                            <label class="details-label mar-rt-10">{{$t('customers.commentsLabel')}}</label>
                            <textarea type="text"
                              min="1"
                              maxlength="255"
                              v-validate=""
                              v-model="newPoints.comments"
                              rows="6"
                              class="form-control "
                              :disabled="loyalty_usage == 0">
                            </textarea>
                        </div>
                        <button type="submit" class="btn btn-success btn-icon mar-rt-10 save mar-to-10" :disabled="loyalty_usage == 0" @click.prevent="addPoints" :title="$t('general.save')">
                          <img src="/static/img/icons/save.png">
                          {{$t('general.save')}}
                        </button>
                    </div>
                <div class="col-md-12 pad-to-25">
                    <h6 class=""><img class="icon-card-header" src="/static/img/icons/commentClient-sm.png">{{$t('customers.addCommentPerClient')}}</h6>
                    <hr style="clear:both;" class="sm">
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="details-label mar-rt-10">{{$t('customers.commentsLabel')}}</label>
                        <textarea type="text"
                                min="1"
                                v-validate=""
                                v-model="customer.comment"
                                rows="8"
                                class="form-control "> </textarea>
                    </div>
                    <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="addComment" :title="$t('general.save')">
                      <img src="/static/img/icons/save.png">
                      {{$t('general.save')}}
                    </button>
                </div>
                <div class="col-md-12 pad-to-25">
                    <h6 class=""><img class="icon-card-header" style="max-width: 30px;" src="/static/img/icons/icon-topBar-settings.png">{{$t('customers.settings')}}</h6>
                    <hr style="clear:both;" class="sm">
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="details-label mar-rt-10">{{$t('customers.allow_virament')}}</label>
                        <p-switch v-model="customer.allow_virament" type="success"></p-switch>
                    </div>
                    <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="saveSettings" :title="$t('general.save')">
                      <img src="/static/img/icons/save.png">
                      {{$t('general.save')}}
                    </button>
                </div>
                <div class="col-md-12">
                    <br>
                    <br>
                    <div class="form-group">
                        <template v-if="customer.user_has_auth_acces">
                          <div 
                            v-for="(location, index) in customer.user_has_auth_acces" 
                            :key="location.true_id"
                            class="location-item"
                          >
                            <span>{{ location.name }}</span>

                            <button 
                              class="delete-btn"
                              @click="removeLocation(location.true_id)"
                            >
                              ✕
                            </button>
                          </div>
                        </template>
                    </div>
                </div>
                </div>
            </div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12" v-if="!is_marketer">
        <div class="action-buttons" style="
            display: flex;
            justify-content: space-between;
            align-items: center;
        ">
          <div class="left-group" style="display: flex; flex-wrap: nowrap; gap: 8px; align-items: flex-end; flex: 0 1 auto; margin-top: 20px; margin-bottom: 20px;">
            <div class="form-group" style="display: flex; flex-direction: column;">
              <label>{{ $t('settingsPages.dateTime') }}</label>
              <el-date-picker
                type="datetimerange"
                v-model="searchDate"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                class="w-100"
                :picker-options="pickerOptions"
                :name="['date_from', 'date_to']"
                :disabled="loading"
              ></el-date-picker>
            </div>

            <div class="form-group" style="
                display: flex;
                flex-direction: column;
            ">
              <label>{{$t('addOrder.choosePay')}}</label>
              <el-select
                v-model="selectedPaymentMethod"
                multiple
                collapse-tags
                :placeholder="$t('settingsPages.filters')"
                class="filter-select"
              >
                <el-option
                  v-for="(val, key) in paymentMethods"
                  :key="key"
                  :label="val.name"
                  :value="val.name">
                </el-option>
              </el-select>
            </div>

            <div class="search-button-reports">
              <button
                :title="$t('reports.search')"
                class="btn add mar-rt-10"
                @click="getData"
              >
                <i class="ti-search"></i>
                <span>{{ $t('general.search') }}</span>
              </button>
            </div>
          </div>
          <div class="right">
            <div class="cust-sales">
              <div class="pull-left">
                <span class="details-label">{{$t('customers.allTimeSale')}}:</span><b> {{formatMoneyAmount(customer.sales)}}</b>
              </div>
            </div>
          </div>
        </div>
        <div class="card mar-bt-0 card-tables">
          <div class="row card-content pad-to-0">
            <data-tables class=""
                      :data="customer.orders"
                      :action-def="defaultActionDef()"
                      :pagination-def="paginationDef"
                      :table-props="{'border': false}"
                      style="width: 100%"
                      @row-click="goToRecord">
              <el-table-column
                :min-width="40"
                sortable
                prop="number"
                :label="$t('customers.number')">
                <template slot-scope="props">
                  #{{props.row.token}}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="50"
                sortable
                prop="date"
                :label="$t('customers.dateCreated')">
                <template slot-scope="props">
                  {{formatDateTime(props.row.created_at)}}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="50"
                sortable
                prop="delivery_type"
                :label="$t('customers.delivery')">
                <template slot-scope="props">
                  {{props.row.delivery_type ? $t('deliveryTypes.' + props.row.delivery_type) : '-'}}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="40"
                sortable
                prop="order_type"
                :label="$t('customers.type')">
                <template slot-scope="props">
                  <span :class="'text-lowercase'">
                  {{$t('ordersTypes.' + props.row.order_type)}}
                </span>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="40"
                sortable
                prop="status"
                :label="$t('customers.status')">
                <template slot-scope="props">
                  <span :class="'label label-' + orderStatusClass(props.row.status.id)">{{$t('ordersStatus.' + props.row.status.id)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="40"
                :class="'text-right'"
                sortable
                prop="payment_type"
                :label="$t('customers.pay')">
                <template slot-scope="props">
                  {{props.row.payment_type}}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="40"
                :class="'text-right'"
                sortable
                prop="total"
                :label="$t('customers.total')">
                <template slot-scope="props">
                  {{formatMoneyAmount(props.row.totals_grandtotal, props.row.currency)}}
                </template>
              </el-table-column>
              <el-table-column
                :min-width="50">
                <template slot-scope="props">
                  <div class="edit">
                    <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                  </div>
                </template>
              </el-table-column>
            </data-tables>
          </div>
        </div> <!-- end card -->
      </div> <!--  end col-md-12  -->

        <div class="col-md-12">
          <br><br><br>
          <div class="card mar-bt-0 card-tables" style="padding: 20px;">
            <div class="row card-content">
                <div class="col-md-12 title">
                    <h6 class=""><img class="icon-card-header" src="/static/img/icons/user-sm.png">Wallet</h6>
                    <hr style="clear:both;" class="sm">
                </div>

              <div class="data-table wallet-table">
                <el-table
                  :data="walletTransactions"
                  :empty-text="$t('gestiune.noData')"
                  style="width: 100%"
                >
                  <!-- ID -->
                  <el-table-column
                    prop="id"
                    label="ID"
                    sortable
                    width="80">
                  </el-table-column>

                  <!-- Amount -->
                  <el-table-column
                    prop="current_value"
                    label="Amount"
                    sortable
                    min-width="120">
                    <template slot-scope="scope">
                      {{ formatMoneyAmount(scope.row.current_value) }}
                    </template>
                  </el-table-column>

                  <!-- Type -->
                  <el-table-column
                    prop="type"
                    label="Type"
                    sortable
                    min-width="150">
                    <template slot-scope="scope">
                      {{ walletTypeLabel(scope.row) }}
                    </template>
                  </el-table-column>

                  <!-- Date -->
                  <el-table-column
                    prop="created_at"
                    label="Date"
                    sortable
                    min-width="150">
                    <template slot-scope="scope">
                      {{ formatDateTime(scope.row.created_at) }}
                    </template>
                  </el-table-column>

                </el-table>

                <el-pagination
                  :total="paginationDef2.total"
                  :page-size="paginationDef2.pageSize"
                  :current-page="paginationDef2.currentPage"
                  layout="prev, pager, next, total"
                  @current-change="getWaletData"
                  style="margin-top: 15px; text-align: center;"
                ></el-pagination>
              </div>

            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Pagination, Select, Option, DatePicker} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import countriesList from './countries'
  import DataTables from 'vue-data-tables'
  import swal from 'sweetalert2'
  Vue.use(Select)
  Vue.use(DatePicker)
  Vue.use(DataTables)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Pagination)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [DatePicker.name]: DatePicker,
      PSwitch
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    created: function () {
      this.loyalty_usage = this.$session.get('selectedCompanyData').loyalty_in_use
      this.loyalty_value_one_currency = this.$session.get('selectedCompanyData').loyalty_value_one_currency
      this.loyalty_value_one_point = this.$session.get('selectedCompanyData').loyalty_value_one_point
      this.loyalty_value_one_point_amount = parseFloat(this.$session.get('selectedCompanyData').loyalty_value_one_point_amount).toFixed(2)
      if (this.$session.get('userDataRole') === 'MARKETER') {
        this.is_marketer = true
      }
      this.getData()
      this.getPaymentMethods()
      this.getActiveSubscriptions()
    },
    data () {
      return {
        loading: true,
        loyalty_value_one_currency: null,
        loyalty_value_one_point: null,
        loyalty_value_one_point_amount: null,
        is_marketer: false,
        customer: [],
        // current subscriptions of the customer (active / ending soon / unpaid / awaiting first payment)
        activeSubscriptions: [],
        newPoints: {
          points_earned: null,
          money_spent: null,
          comments: null
        },
        countries: countriesList,
        currency: '',
        modelValidations: {
          required: {
            required: true
          }
        },
        paginationDef: {
          pageSize: 10,
          currentPage: 1,
          pageSizes: [10, 25, 50],
          show: true
        },
        loyalty_usage: null,
        searchDate: null,
        paymentMethods: null,
        pickerOptions: {
          shortcuts: [
            {
              text: 'Astăzi',
              onClick (picker) {
                const start = new Date()
                start.setHours(0, 0, 0, 0)
                const end = new Date()
                end.setHours(23, 59, 59, 999)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Ieri',
              onClick (picker) {
                const start = new Date()
                start.setDate(start.getDate() - 1)
                start.setHours(0, 0, 0, 0)
                const end = new Date()
                end.setDate(end.getDate() - 1)
                end.setHours(23, 59, 59, 999)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Ultimele 7 zile',
              onClick (picker) {
                const end = new Date()
                end.setHours(23, 59, 59, 999)
                const start = new Date()
                start.setDate(end.getDate() - 6)
                start.setHours(0, 0, 0, 0)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Ultimele 30 de zile',
              onClick (picker) {
                const end = new Date()
                end.setHours(23, 59, 59, 999)
                const start = new Date()
                start.setDate(end.getDate() - 29)
                start.setHours(0, 0, 0, 0)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Luna curentă',
              onClick (picker) {
                const start = new Date()
                start.setDate(1)
                start.setHours(0, 0, 0, 0)
                const end = new Date()
                end.setHours(23, 59, 59, 999)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Luna trecută',
              onClick (picker) {
                const date = new Date()
                const start = new Date(date.getFullYear(), date.getMonth() - 1, 1)
                start.setHours(0, 0, 0, 0)
                const end = new Date(date.getFullYear(), date.getMonth(), 0)
                end.setHours(23, 59, 59, 999)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Anul curent',
              onClick (picker) {
                const start = new Date(new Date().getFullYear(), 0, 1)
                start.setHours(0, 0, 0, 0)
                const end = new Date()
                end.setHours(23, 59, 59, 999)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: 'Anul trecut',
              onClick (picker) {
                const year = new Date().getFullYear() - 1
                const start = new Date(year, 0, 1)
                start.setHours(0, 0, 0, 0)
                const end = new Date(year, 11, 31)
                end.setHours(23, 59, 59, 999)
                picker.$emit('pick', [start, end])
              }
            }
          ],
          onPick ({ maxDate, minDate }) {
            if (minDate && !maxDate) {
              minDate.setHours(0, 0, 0, 0)
            }
            if (maxDate) {
              maxDate.setHours(23, 59, 59, 999)
            }
          }
        },
        selectedPaymentMethod: null,
        walletTransactions: [],
        paginationDef2: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        }
      }
    },
    methods: {
      getActiveSubscriptions () {
        if (!this.route.params || !this.route.params.id) {
          return
        }
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          user_id: this.route.params.id,
          per_page: 100
        }
        this.apiRequest('/subscription/subscribers', 'GET', data, (response) => {
          if (response.status === true && response.data) {
            const current = ['active', 'expiring', 'unpaid', 'pending']
            this.activeSubscriptions = (response.data.items || []).filter(item => current.indexOf(item.state) !== -1)
          }
        })
      },
      getData () {
        this.$nextTick(function () {
          this.loading = true
        })
        var currency = this.getCompanyDetail('currency')
        this.currency = this.getCurrencySymbol(currency)
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        // Adaugă date_from și date_to dacă există
        if (this.searchDate && this.searchDate.length === 2) {
          data.date_from = this.searchDate[0]
          data.date_to = this.searchDate[1]
        }

        // Adaugă payment_type dacă există
        if (this.selectedPaymentMethod && this.selectedPaymentMethod.length > 0) {
          data.payment_type = this.selectedPaymentMethod
        }

        var self = this
        // get product data
        if (self.route.params.id) {
          var id = self.route.params.id
          self.apiRequest('/customer/' + id, 'GET', data, function (response) {
            if (response.status === true) {
              var goodOrders = []
              for (var idx in response.data[0].orders) {
                if (response.data[0].orders[idx]['status'].id !== 'DRAFT') {
                  goodOrders.push(response.data[0].orders[idx])
                }
              }
              response.data[0].orders = goodOrders
              self.customer = response.data[0]
              self.customer.allow_virament = !!self.customer.allow_virament

              self.getWaletData()

              self.$nextTick(function () {
                self.loading = false
              })
            }
          })
        }
      },
      getWaletData (page = 1) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          user_id: this.route.params.id,
          page: page,
          per_page: this.paginationDef2.pageSize
        }

        this.apiRequest('/reports/get-user-wallet-transactions', 'GET', data, (response) => {
          this.walletTransactions = response.data.wallet_transactions.data
          this.paginationDef2.currentPage = response.data.wallet_transactions.current_page
          this.paginationDef2.total = response.data.wallet_transactions.total
        })
      },
      walletTypeLabel (row) {
        if (row.type === 1) {
          return `Minus (Order ${row.order_id})`
        }

        if (row.type === 2) {
          return `Gift Card (${row.gift_card_id})`
        }

        return '-'
      },
      addPoints () {
        var self = this
        if (!this.newPoints.money_spent || !this.newPoints.comments) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.validPoinsNo'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
        } else {
          var id = this.route.params.id
          var data = {
            user_id: id,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            money_spent: this.newPoints.money_spent,
            comments: this.newPoints.comments,
            money_spent_confirm: 1,
            send_notifications: 0
          }

          swal({
            type: 'question',
            text: self.$t('customers.clientNotification'),
            position: 'top-end',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: self.$t('general.yes'),
            cancelButtonText: self.$t('general.no')
          }).then((result) => {
            if (result) {
              data.send_notifications = 1
              self.apiRequest('/loyalty-points', 'POST', data, function (response) {
                if (response.status === true) {
                  swal(
                    '',
                    response.data.message,
                    'success'
                  )
                  self.customer.loyalty_points = parseInt(response.data.loyalty_points)
                  self.newPoints.money_spent = null
                  self.newPoints.points_earned = null
                  self.newPoints.comments = null
                } else {
                  swal(
                    '',
                    response.errors.company_id !== undefined ? response.errors.company_id : self.$t('customers.points'),
                    'error'
                  )
                }
              })
            }
          }, function (dismiss) {
            if (dismiss === 'cancel') {
              self.apiRequest('/loyalty-points', 'POST', data, function (response) {
                if (response.status === true) {
                  swal(
                    '',
                    response.data.message,
                    'success'
                  )
                  self.customer.loyalty_points = parseInt(response.data.loyalty_points)
                  self.newPoints.money_spent = null
                  self.newPoints.points_earned = null
                  self.newPoints.comments = null
                } else {
                  swal(
                    '',
                    response.errors.company_id !== undefined ? response.errors.company_id : self.$t('customers.points'),
                    'error'
                  )
                }
              })
            }
          })
        }
      },
      goToRecord (row, event, column) {
        this.backButton()
        this.globalGoToRecord(row, event, column, '/orders/view/')
      },
      getPaymentMethods () {
        let sessionData = this.$session.get('selectedCompanyData')

        if (!sessionData['payment_methods']) {
          var data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }

          this.apiRequest('/orders/get-payment-methods', 'GET', data, (response) => {
            if (response.status && response.data.length) {
              let result = response.data.map(item => {
                return {id: item || 'unpaid', name: this.$t('paymentTypes.' + item)}
              })
              sessionData['payment_methods'] = response.data
              this.$session.set('selectedCompanyData', sessionData)

              Vue.set(this, 'paymentMethods', result)
            }
          })
        } else {
          let result = sessionData['payment_methods'].map(item => {
            return {id: item || 'unpaid', name: this.$t('paymentTypes.' + item)}
          })
          Vue.set(this, 'paymentMethods', result)
        }
      },
      addComment () {
        this.$nextTick(function () {
          this.loading = true
        })
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          comment: this.customer.comment
        }
        var self = this
        if (self.route.params.id) {
          var id = self.route.params.id
          self.apiRequest('/add-customer-comment/' + id, 'PUT', data, function (response) {
            if (response.status === true) {
              swal({
                toast: true,
                type: 'success',
                text: self.$t('customers.newCommentAdded'),
                showConfirmButton: false,
                timer: 2000
              })
            } else {
              swal(
                '',
                response.errors.id !== undefined ? response.errors.id : 'error',
                'error'
              )
            }
            self.$nextTick(function () {
              self.loading = false
            })
          })
        }
      },
      saveSettings () {
        this.$nextTick(function () {
          this.loading = true
        })
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          allow_virament: this.customer.allow_virament
        }
        var self = this
        if (self.route.params.id) {
          var id = self.route.params.id
          self.apiRequest('/customer-update/' + id, 'PUT', data, function (response) {
            if (response.status === true) {
              swal({
                toast: true,
                type: 'success',
                text: self.$t('customers.newCommentAdded'),
                showConfirmButton: false,
                timer: 2000
              })
            } else {
              swal(
                '',
                response.errors.id !== undefined ? response.errors.id : 'error',
                'error'
              )
            }
            self.$nextTick(function () {
              self.loading = false
            })
          })
        }
      },
      calcPoints ($part) {
        if (this.loyalty_value_one_currency) {
          if ($part === 1) {
            this.newPoints.points_earned = (this.newPoints.money_spent * this.loyalty_value_one_currency).toFixed(2)
          } else {
            this.newPoints.money_spent = (this.newPoints.points_earned / this.loyalty_value_one_currency).toFixed(2)
          }
        }
      },
      removeLocation (locationId) {
        var id = this.route.params.id
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_id: locationId,
          user_id: id
        }
        this.apiRequest('/remove-auth-location/', 'POST', data, (response) => {
          if (response.status === true) {
            this.getData()
          }
        })
      },
      backButton () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>
<style>
  .money_section .details-label {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .money_section .details-label span {
    font-size: 12px;
  }
  .customer-subscription {
    display: inline-block;
    margin: 0 6px 4px 0;
    padding: 2px 10px;
    border-radius: 10px;
    font-size: 12px;
    border: 1px solid #a5d6a7;
    background: #e8f5e9;
    color: #2e7d32;
  }
  .customer-subscription--expiring,
  .customer-subscription--unpaid {
    border-color: #ffe082;
    background: #fff8e1;
    color: #8d6e00;
  }
  .customer-subscription--pending {
    border-color: #bbdefb;
    background: #e3f2fd;
    color: #1565c0;
  }
  .customer-subscription__norenew {
    margin-left: 4px;
    color: #c62828;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Customers/CustomerView.vue